import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "category__breadcrumbs" }
const _hoisted_2 = { class: "category__menu-listing-facets" }
const _hoisted_3 = {
  key: 0,
  class: "category__number-of-products"
}
const _hoisted_4 = { class: "category__product-list" }

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';

import useDynamicProductListing from '@/composables/useDynamicProductListing';
import useMeta from '@/composables/useMeta';
import useContext from '@/composables/useContext';
import useWindowResize from '@/composables/useWindowResize';

import Breadcrumbs from '@/components/Breadcrumbs.vue';
import SubCategories from '@/components/Category/SubCategories.vue';
import ListingFacets from '@/components/ListingFacets';
import ScrollToTopButton from '@/components/ScrollToTopButton';
import ProductCard from '@/components/ProductCard';


export default /*#__PURE__*/_defineComponent({
  __name: 'Category',
  setup(__props) {

useMeta();
const { page } = useContext();
const {
  context,
  category,
  gridProducts,
  isLoadingProducts,
  facets,
  disableCategoryMenu,
  productCount,
} = useDynamicProductListing();
const { isCustomDevice } = useWindowResize({ min: 0, max: 839 });

const categoryEl = ref<HTMLDivElement | null>(null);
const categoryProductListEl = ref<HTMLDivElement | null>(null);
const isListingFacetsSticky = ref(false);

const headerOffsetTop = 35;

const threshold = computed(() => (isCustomDevice.value ? 85 : 90));
const headerOffsetBottom = computed(() => (isCustomDevice.value ? 75 : 50));

const isLocked = computed(() => page.value?.dataJson?.category?.isLocked || false);
const selectedSizeFacet = computed(() => {
  if (typeof facets.value.find !== 'function') {
    return null;
  }
  return facets.value.find((facet) => facet.id === 'Size')?.selectedValues?.map((v) => v.label) || null;
});

const categoryBreadCrumbs = computed(() => {
  return {
    parents: category.value?.parents?.filter((p: any) => p.url && p.name).reverse() || [],
    name: category.value?.name,
    url: category.value?.url,
  };
});

function updateStickyClassBasedOnScroll() {
  if (!categoryEl.value || !categoryProductListEl.value) {
    return;
  }

  const scrollY = window.scrollY + threshold.value;
  const categoryMenuTop = categoryProductListEl.value.offsetTop - headerOffsetTop;
  const categoryBottom = categoryEl.value.offsetTop + categoryEl.value.offsetHeight - headerOffsetBottom.value;

  isListingFacetsSticky.value = scrollY > categoryMenuTop && scrollY < categoryBottom;
}

onMounted(() => {
  nextTick(() => {
    updateStickyClassBasedOnScroll();
  });

  window.addEventListener('scroll', updateStickyClassBasedOnScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateStickyClassBasedOnScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ScrollToTopButton), { "trigger-distance-from-top": 200 }),
    _createVNode(_component_blocks_repeater, {
      blocks: _unref(page)?.blocks?.Main
    }, null, 8, ["blocks"]),
    (!_unref(isLocked))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category",
          ref_key: "categoryEl",
          ref: categoryEl
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Breadcrumbs, { category: _unref(categoryBreadCrumbs) }, null, 8, ["category"])
          ]),
          _createVNode(SubCategories),
          _createElementVNode("div", {
            class: _normalizeClass([
            'category__menu',
            {
              'category__menu--disabled': _unref(disableCategoryMenu),
              'category__menu--sticky': isListingFacetsSticky.value,
            },
          ])
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_unref(context))
                ? (_openBlock(), _createBlock(_unref(ListingFacets), { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (_unref(isCustomDevice))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(productCount)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["category__product-list-wrapper", { 'category__product-list-wrapper--loading': _unref(isLoadingProducts) }]),
            ref_key: "categoryProductListEl",
            ref: categoryProductListEl
          }, [
            _createVNode(_component_blocks_repeater, {
              blocks: _unref(page)?.blocks?.Grid
            }, null, 8, ["blocks"]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gridProducts), (product) => {
                return (_openBlock(), _createBlock(_unref(ProductCard), {
                  key: product.articleNumber,
                  class: "category__product-item",
                  product: product,
                  "size-filter": _unref(selectedSizeFacet)
                }, null, 8, ["product", "size-filter"]))
              }), 128))
            ])
          ], 2)
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_blocks_repeater, {
      blocks: _unref(page)?.blocks?.Bottom
    }, null, 8, ["blocks"])
  ]))
}
}

})